import { lazy } from '@/service/lazy'

export default [{
  name: 'Consulta Extrato',
  path: 'consultaextrato',
  id: 'consultaextrato',
  icon: 'fa fa-file-text',
  component: lazy('app/default/extrato/index'),
  meta: { requireAuth: true, rules: ['consulta_extrato'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/extrato.js